export const product = 'product'
export const structure = 'structure'
export const category = 'category'
export const direction = 'direction'
export const brand = 'brand'

